import { ApiError, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { SliceStatus } from '@frontend/common';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toNumber } from 'lodash';

import { TransactionClient } from '../api/transaction-client';
import { Transaction, TransactionListResponse } from '../transaction';

interface TransactionState {
    unordered: Transaction[];
    transactions: TransactionListResponse | null;
    status: SliceStatus;
}

const initialState: TransactionState = {
    unordered: [],
    transactions: null,
    status: SliceStatus.INIT
};

export const transactionSlice = createSlice({
    name: 'transactions',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTransactions.pending, (state) => {
                state.status = SliceStatus.LOADING;
            })
            .addCase(fetchTransactions.fulfilled, (state, action) => {
                const startPos = toNumber(action.meta.arg.size) * (toNumber(action.meta.arg.index) - 1);
                if (state.transactions == null) {
                    state.transactions = {
                        ...action.payload,
                        results: new Array(action.payload.count)
                    };
                    state.transactions.results.splice(startPos, action.payload.results.length, ...action.payload.results);
                } else {
                    if (state.transactions.results.length !== action.payload.count) {
                        state.transactions.count = action.payload.count;
                        state.transactions.results = new Array(action.payload.count);
                    }
                    state.transactions.results.splice(startPos, action.payload.results.length, ...action.payload.results);
                }
                state.unordered = [
                    ...state.unordered.filter((account) => action.payload.results.find((a) => a.id == account.id) == undefined),
                    ...action.payload.results
                ];
                state.status = SliceStatus.IDLE;
            });
    }
});

export const fetchTransactions = createAsyncThunk<TransactionListResponse, ApiQueryParams<DefaultQueryParams>>(
    'fetchTransactions',
    async (queryParams: ApiQueryParams<DefaultQueryParams>, { rejectWithValue }) => {
        try {
            return await TransactionClient.fetchTransactions(queryParams);
        } catch (e) {
            if ((e as ApiError).json) return rejectWithValue(e);
            throw e;
        }
    }
);
